import uniqBy from 'lodash/uniqBy';
import {
    APPLY_CHANNELS_FILTERS,
    CHANNELS_PACKAGE_ID,
    CLEAR_CHANNELS_PACKAGE_ID,
    CLEAR_SEARCH_CHANNELS_FILTER,
    CLEAR_THEME_CHANNELS_FILTER,
    GET_ALL_CHANNELS,
    GET_BUNDLES_BANNER,
    GET_BUNDLES_TARIFFS,
    GET_BUNDLES_TARIFFS_SELF_ORDER,
    GET_CHANNELS_BY_BIDS,
    GET_CHANNEL_THEMES,
    SET_FILTERED_TARIFFS_ID,
    SET_FILTER_FOR_CHANNELS,
    SET_SEARCH_CHANNELS_FILTER,
    SET_SELECTED_TARIFF_ID,
    SET_TARIFF_CHANNELS,
    SET_THEME_CHANNELS_FILTER,
} from '../actionTypes/bundles';
import cloneDeep from 'lodash/cloneDeep';
import { HYDRATE } from 'next-redux-wrapper';

export const initialState = {
    banner: null,
    themeId: 0,
    tariffs: {
        byId: {},
        allIds: [],
    },
    tariffsSelfOrder: {
        byId: {},
        allIds: [],
    },
    allChannels: [],
    channelsByBids: {},
    channelThemes: [],
    tariffChannels: [],
    channelsFilters: {},
    channelsFiltersIsApply: false,
    filteredChannels: [],
    selectedTariffId: '',
    selectedFilter: { value: 0, label: 'Все каналы', list: [] },
    filteredTariffsId: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.bundles };

        case GET_BUNDLES_BANNER: {
            return {
                ...state,
                banner: action.payload,
            };
        }

        case GET_BUNDLES_TARIFFS: {
            return {
                ...state,
                tariffs: normalizeBundlesList(action.payload),
            };
        }

        case GET_BUNDLES_TARIFFS_SELF_ORDER: {
            return {
                ...state,
                tariffsSelfOrder: normalizeBundlesList(action.payload),
            };
        }

        case GET_ALL_CHANNELS: {
            return {
                ...state,
                allChannels: action.payload,
            };
        }

        case GET_CHANNELS_BY_BIDS: {
            const channelsByBids = state.channelsByBids;
            channelsByBids[action.payload.bids.toString()] = action.payload.channels;

            return {
                ...state,
                channelsByBids,
            };
        }

        case SET_SEARCH_CHANNELS_FILTER: {
            return {
                ...state,
                channelsFilters: {
                    ...state.channelsFilters,
                    search: action.payload,
                }
            };
        }

        case CLEAR_SEARCH_CHANNELS_FILTER: {
            const filters = cloneDeep(state.channelsFilters);
            delete filters.search;

            return {
                ...state,
                channelsFilters: filters,
            };
        }

        case SET_THEME_CHANNELS_FILTER: {
            return {
                ...state,
                channelsFilters: {
                    ...state.channelsFilters,
                    theme: action.payload,
                }
            };
        }

        case CLEAR_THEME_CHANNELS_FILTER: {
            const filters = cloneDeep(state.channelsFilters);
            delete filters.theme;
            return {
                ...state,
                channelsFilters: filters,
            };
        }

        case APPLY_CHANNELS_FILTERS: {
            const filters = state.channelsFilters;

            const channels = state.tariffChannels;
            const isHaveFilters = Object.keys(filters).length > 0;

            if (!isHaveFilters || !channels) {
                return {
                    ...state,
                    channelsFiltersIsApply: false,
                };
            }

            let filteredChannels = cloneDeep(channels);

            const isSearch = !!state.channelsFilters?.search && state.channelsFilters.search !== '';

            if (isSearch) {
                for (const key in filters) {
                    if (key === 'search') {
                        const searchValue = filters[key];

                        filteredChannels = filteredChannels.filter(channel => channel.title.toLowerCase().includes(searchValue));
                    }
                }
            } else {
                for (const key in filters) {
                    if (key === 'theme') {
                        const themeId = filters[key];

                        filteredChannels = filteredChannels.filter(channel => channel.thid === themeId);
                    }
                }
            }

            return {
                ...state,
                channelsFiltersIsApply: true,
                filteredChannels,
            };
        }

        case GET_CHANNEL_THEMES: {
            const themes = action.payload;
            const formattedThemes = themes.map(theme => ({
                value: theme.thid,
                label: theme.plural,
                name: theme.name,
                weight: +theme.weight
            })).sort((a, b) => a.weight - b.weight);

            return {
                ...state,
                channelThemes: formattedThemes,
            };
        }

        case SET_TARIFF_CHANNELS: {
            const packages = action.payload;
            const channels = state.allChannels;

            const tariffChannels = channels
                .filter(channel => packages.includes(channel.bid))
                .map(channel => {
                    const httpRegExp = /^http/;

                    if (channel.logo && !httpRegExp.test(channel.logo)) {
                        channel.logo = `${process.env.EPG_API_ENDPOINT}${channel.logo}`;
                    }

                    return channel;
                });

            const uniqChannels = uniqBy(tariffChannels, channel => channel.chid);

            return {
                ...state,
                tariffChannels: uniqChannels
            };
        }

        case CHANNELS_PACKAGE_ID: {
            return { ...state, themeId: action.payload };
        }

        case CLEAR_CHANNELS_PACKAGE_ID: {
            const idToShowAllChannels = 0;
            return { ...state, themeId: idToShowAllChannels };
        }

        case SET_SELECTED_TARIFF_ID:
            return ({
                ...state,
                selectedTariffId: action.payload
            });

        case SET_FILTER_FOR_CHANNELS:
            return ({
                ...state,
                selectedFilter: action.payload
            });

        case SET_FILTERED_TARIFFS_ID: {
            return { ...state, filteredTariffsId: [...action.payload] };
        }

        default: {
            return state;
        }
    }
};

function normalizeBundlesList(tariffs) {
    const ids = Object.keys(tariffs);
    return {
        byId: tariffs,
        allIds: [...ids],
    };
}
